import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import TextField from '@mui/material/TextField';
import SimpleDialog from '../../Simple/Dialog/SimpleDialog';
import { getBaseDomain } from '../../../api/endpointBuilder';

type SavedLinkCopyType = {
	codeTaskId: string;
	open: boolean;
	onClose: () => void;
};

const SavedLinkCopy: FC<SavedLinkCopyType> = ({
	codeTaskId,
	open,
	onClose,
}) => {
	const { t } = useTranslation();
	const [isCopied, setIsCopied] = useState(false);

	useEffect(() => {
		setIsCopied(false);
	}, [codeTaskId]);

	const domain = getBaseDomain();

	const link = `${domain}/code/s/${codeTaskId}`;

	const copyLink = () => {
		navigator.clipboard.writeText(link);
		setIsCopied(true);
	};

	const content = (
		<div>
			<Typography variant="body1">{t('copyLinkText')}</Typography>
			<div style={{ display: 'flex' }}>
				<TextField
					style={{ width: '300px', marginRight: '10px' }}
					id="standard-basic"
					variant="standard"
					disabled
					value={link}
				/>
				{!isCopied ? (
					<Tooltip title={t('copy')} placement="top">
						<ContentCopyIcon
							color="primary"
							style={{ cursor: 'pointer' }}
							onClick={copyLink}
						/>
					</Tooltip>
				) : (
					<Tooltip title={`${t('copied')}!`} placement="top">
						<LibraryAddCheckIcon color="success" style={{ cursor: 'pointer' }} />
					</Tooltip>
				)}
			</div>
		</div>
	);
	return (
		<SimpleDialog
			title={t('codeWasSaved')}
			content={content}
			open={open}
			onClose={onClose}
		/>
	);
};

export default SavedLinkCopy;
